import { useEffect, useMemo } from 'react';
import { useAtom } from 'jotai/index';
import { useFormik } from 'formik';
import { FormTagField } from 'shared/_ui/form/form-tag-field';
import { debounce } from 'shared/_utils';
import { projectListSettingsAtom } from 'shared/_model/project/project-list/store';
import { PageFilters } from 'shared/_components/page/styles';

type FilterValues = {
	tags: string[];
};

const initialValues: FilterValues = { tags: [] };

export default function ProjectListFilters() {
	const formik = useFormik<FilterValues>({
		initialValues,
		onSubmit: () => undefined,
	});

	const [{ showFilters }, setSettings] = useAtom(projectListSettingsAtom);

	const handleChange = useMemo(() =>
		debounce(({ tags }: FilterValues) => {
			const tagsFilter = tags.length ? [{ tags: { $in: tags } }] : [];
			setSettings((s) => ({
				...s,
				filters: [...tagsFilter],
			}));
		}), [setSettings]);

	useEffect(() => {
		handleChange(formik.values);
	}, [handleChange, formik.values]);

	if (!showFilters) {
		return null;
	}

	return (
		<PageFilters>
			<FormTagField
				label="Tags:"
				name="tags"
				fullWidth
				formik={formik}
				labelProps={{ width: '2.875rem' }}
			/>
		</PageFilters>
	);
}
